import { Component, Input } from '@angular/core';

/**
 * @description Component
 * @class ProgressbarComponent
 */
@Component({
  standalone: false,
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss']
})
export class ProgressbarComponent {
  @Input() progress = 0;

  @Input() actualStep = 4;

  @Input() totalStep = 5;
  /**
   * @description Creates an instance of ProgressbarComponent.
   */
  constructor() { }
}
